import { Fragment, useEffect, useState } from "react";
import { isValidArray } from "../../../Layout/Common/common";

export const FilterManufacuture = ({ params, handleChange }) => {
  const [manufacutureJson, setManufacutureJson] = useState(null);
  const [manufacture, setManufacture] = useState(null);

  useEffect(() => {
    if (params && isValidArray(params)) {
      setManufacutureJson(params);
    }
  }, []);

  useEffect(() => {
    //handleChange(manufacture);
  }, [manufacture]);

  const handleManufactureChange = (e) => {
    const { value, checked } = e.target;

    if (checked) {
      // Add the value to the array if checked
      setManufacture([...(manufacture || []), value]);
    } else {
      // Remove the value from the array if unchecked
      setManufacture(manufacture.filter((item) => item != value));
    }
  };

  return (
    <Fragment>
      {isValidArray(manufacutureJson) && (
        <div className={`manufacture-filter manufactureFilter-selected ${isValidArray(manufacture) && `active`}`}>
          <div className="dropdown filterSortby">
            <button
              className={`btn filter-btn manufatureFilter manufatureFilter-dropdown dropdown-toggle ${
                isValidArray(manufacture) && `show`
              }`}
              type="button"
              id="manufacturedropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span>
                Manufacturer
                <small className="manufatureFilter-count">{isValidArray(manufacture) && manufacture.length}</small>
              </span>
              <i className="fa-solid fa-chevron-down" />
            </button>
            <div
              className="dropdown-menu manufatureFilter-dropdownMenu dropdown-menu-end"
              aria-labelledby="manufacturedropdown"
              style={{}}
            >
              {/* Manufacture list */}
              <div className="manufacture-filter-list">
                {manufacutureJson.map((item, index) => (
                  <div className="manufacture-filterList-content manuFilter-content" key={index}>
                    <div className="common-checkbox-selection">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={item.id}
                        value={item.name}
                        onChange={handleManufactureChange}
                      />
                    </div>
                    <label className="form-check-label" htmlFor={item.id}>
                      {item.name}
                      <span>({item.count})</span>
                    </label>
                  </div>
                ))}
                <div className="button-effect manufactureBtn">
                  <button type="button" id="manufactureBtn" className="btn btn-products btn-addcart">
                    Apply
                  </button>
                </div>
              </div>
              {/* Manufacture list */}
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};
